import Application from "../../Application";
import { IApplicantFormService } from "../../service/form/ApplicantFormService";

export default class MarkForAdditionalCheckInteractor {
  private application: Application;
  private applicantFormService: IApplicantFormService;

  constructor(application, applicantFormService) {
    this.application = application;
    this.applicantFormService = applicantFormService;
  }

  async execute(
    applicantReportingPeriodId: number,
    reasonAdditionalCheck?: string
  ) {
    return this.applicantFormService.markForAdditionalCheck(
      applicantReportingPeriodId,
      reasonAdditionalCheck
    );
  }
}
